import { FieldMap, FieldMapValue, InfoStage, PopulatedAssessment } from '../../types'
import { AssessmentForm } from '../../types/assessments/form'

import { deliveryStage, midwifeOnlyDeliveryStage } from './delivery'
import { getInsuranceInfoStage } from './insuranceInfo'

export const getIntroductionFormStages = (
  admin: boolean,
  data?: FieldMapValue,
): Record<string, FieldMap | InfoStage> => {
  const insuranceInfo = getInsuranceInfoStage(data?.insuranceInfo, false, admin)

  const notPregnant = data?.insuranceInfo?.option === 'not-pregnant'
  if (notPregnant) {
    const notPregnantOption = data?.insuranceInfo?.notPregnantOption
    if (notPregnantOption === 'current-plan') {
      return {
        insuranceInfo,
        delivery: midwifeOnlyDeliveryStage,
      }
    }
    return {
      insuranceInfo,
    }
  }
  return {
    insuranceInfo,
    delivery: deliveryStage,
  }
}

export const getIntroductionForm = (
  admin: boolean,
  assessment?: Omit<PopulatedAssessment, 'availableForms' | 'stages' | 'plans'> | null,
  // data?: FieldMapValue,
  // mergedData?: FieldMapValue,
): AssessmentForm => ({
  name: 'Introduction',
  description: 'Tell us a little bit about your pregnancy',
  stages: getIntroductionFormStages(admin, admin ? assessment?.mergedData : assessment?.data),
  getNextFormId: (admin, assessment) => {
    const { data, mergedData } = assessment ?? {}

    const insuranceInfoData = admin ? mergedData?.insuranceInfo : data?.insuranceInfo

    // const primaryCoverage = insuranceInfoData?.primaryCoverage

    // const secondaryCoverage = insuranceInfoData?.secondaryCoverage

    // const { insuranceProvider: primaryInsurer } = primaryCoverage ?? {}
    // const { insuranceProvider: secondaryInsurer } = secondaryCoverage ?? {}

    const option = insuranceInfoData?.option
    // const coverageWillChangeOption = insuranceInfoData?.coverageWillChangeDescription
    const noCoverageOption = insuranceInfoData?.noCoverageDescription
    const multipleOptionsOption = insuranceInfoData?.multipleOptionsDescription
    const notPregnantOption = insuranceInfoData?.notPregnantOption
    // const canEnrollInPartnerPlan = insuranceInfoData?.canEnrollInPartnerPlan

    // const getCallInForInsurer = (insurer: InsuranceProvider) => {
    //   if (insurer?.loqNotRequired) return null
    //   return 'call-in'
    // }

    // const getCallIn = () => {
    //   if (insurerCallStatus !== 'opted-in') return null
    //   const hasPrimaryCoverage = getHasPrimaryCoverage(insuranceInfoData)
    //   const primaryIsMedicaid = getPrimaryIsMedicaid(insuranceInfoData)
    //   if (hasPrimaryCoverage && !primaryIsMedicaid) return getCallInForInsurer(primaryInsurer)
    //   const secondaryIsMedicaid = getSecondaryIsMedicaid(insuranceInfoData)
    //   const hasSecondaryCoverage = getHasSecondaryCoverage(insuranceInfoData)
    //   if (hasSecondaryCoverage && !secondaryIsMedicaid) return getCallInForInsurer(secondaryInsurer)
    //   return null
    // }

    if (!option) return null
    switch (option) {
      case 'one-plan':
        return null
      case 'two-plans':
        return null
      case 'medicaid':
        return null
      case 'coverage-will-change':
        // switch (coverageWillChangeOption) {
        //   case 'employment-coverage-will-change':
        //     return null
        //   case 'employment-coverage-will-change-unknown':
        //     return 'schedule-call'
        //   case 'coverage-will-drop':
        //     return 'plan-options'
        //   case 'added-to-another-plan':
        //     return null
        //   default:
        //     return null
        // }
        return null
      case 'multiple-options':
        switch (multipleOptionsOption) {
          case 'partner-individual':
            return null
          case 'partner-employer':
            return null
          default:
            return null
        }
      case 'not-pregnant':
        switch (notPregnantOption) {
          case 'current-plan':
            return null
          case 'other-options':
            return 'plan-options'
          case 'no-coverage':
            return 'plan-options'
          default:
            return null
        }
      case 'no-coverage':
        if (noCoverageOption === 'out-of-pocket') {
          return null
        }
        return 'plan-options'
      default:
        return null
    }
  },
})
